import { Col, Flex, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const UrlErrorDetail = ({ urlErrorList }: { urlErrorList: string[] }) => {
  const { t } = useTranslation("translation", { keyPrefix: "NETWORK_CHECK" });
  return (
    <Flex vertical gap={4}>
      <Text style={{ whiteSpace: "pre-line" }}>{t("URL_CHECK_ERROR_MESSAGE")}</Text>
      <div className="affect-url-container">
        <ul>
          <li>{t("AFFECTED_URLS")}</li>
        </ul>
        <ul className="affect-url-list">
          {urlErrorList.map((url) => (
            <li style={{ color: "#fff" }} key={url}>
              <Text>{url}</Text>
            </li>
          ))}
        </ul>
      </div>
      <Text>{t("CONTACT_SUPPORT")}</Text>
      <Row className="grid-detail" gutter={[20, 20]}>
        <Col span={6}>
          <Text strong>{t("OTHER_REGION_TITLE")}</Text>
        </Col>
        <Col span={18}>
          <Flex vertical>
            <Text>{t("OTHER_REGION_DETAIL_1")} </Text>
            <Text>{t("OTHER_REGION_DETAIL_2")}</Text>
          </Flex>
        </Col>
        <Col span={6}>
          <Text strong>{t("JP_REGION_TITLE")}</Text>
        </Col>
        <Col span={18}>
          <Text style={{ whiteSpace: "pre-line" }}>{t("JP_REGION_DETAIL")}</Text>
        </Col>
      </Row>
    </Flex>
  );
};

export default UrlErrorDetail;
